// extracted by mini-css-extract-plugin
export var container = "_sg-0";
export var inputWidth = "_sg-1";